import React from 'react';
import { Select } from 'antd';
import { getSegmentGroup, Segment, SegmentGroup } from '@fxtr/i18n';
import config from '$config';

const { Option } = Select;

const allSegmentOptions = [
  { value: Segment.Fixter_UK, label: 'United Kingdom 🇬🇧' },
  { value: Segment.Fixter_FR, label: 'France 🇫🇷' },
  { value: Segment.Motrio_UK, label: 'Motrio UK 🇬🇧' },
  { value: Segment.Motrio_FR, label: 'Motrio France 🇫🇷' },
  { value: Segment.Motrio_IT, label: 'Motrio Italy 🇮🇹' },
  { value: Segment.Motrio_ES, label: 'Motrio Spain 🇪🇸' },
  { value: Segment.Motrio_PT, label: 'Motrio Portugal 🇵🇹' },
  { value: Segment.Motrio_NL, label: 'Motrio Netherlands 🇳🇱' },
  { value: Segment.Motrio_RO, label: 'Motrio Romania 🇷🇴' },
  { value: Segment.Motrio_PL, label: 'Motrio Poland 🇵🇱' },
  { value: Segment.Renault_MA, label: 'Renault Morocco 🇲🇦' },
];

export const segmentOptionsForDeployment = (segmentGroup = config.segmentGroup) =>
  allSegmentOptions.filter((option) => getSegmentGroup(option.value) === segmentGroup);

export const segmentLabel = (segment) =>
  allSegmentOptions.find((option) => option.value === segment)?.label || segment || '';

/** Promos with no market are the existing Fixter ones. Partner deployments only see their own. */
export const campaignVisibleForDeployment = (segment, segmentGroup = config.segmentGroup) => {
  if (!segment) return segmentGroup === SegmentGroup.FIXTER;

  try {
    return getSegmentGroup(segment) === segmentGroup;
  } catch (err) {
    return false;
  }
};

export default function CampaignSegmentSelect(props) {
  const options = segmentOptionsForDeployment();
  const current = props.value;
  const visibleOptions =
    current && !options.some((option) => option.value === current)
      ? [...options, { value: current, label: segmentLabel(current) }]
      : options;

  return (
    <Select {...props}>
      {visibleOptions.map((option) => (
        <Option key={option.value} value={option.value}>
          {option.label}
        </Option>
      ))}
    </Select>
  );
}
